'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _expires;

var _utils = require('../utils');

var _ttl2 = require('./_ttl');

var _ttl3 = _interopRequireDefault(_ttl2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _expires() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
    }

    for (var i = 0; i < args.length; i++) {
        if (!(0, _utils.isNil)(args[i].expires)) return args[i].expires;
    }return Date.now() + _ttl3.default.apply(undefined, args);
}